<template>
  <div>
    <el-form
      label-position="right"
      label-width="100px"
      :class="border ? 'box' : ''"
    >
      <el-form-item :label="carrying001" class="operator-user-selector">
        <employee-input
          v-model="value.carrying001"
          :padding="0"
        ></employee-input>
      </el-form-item>
      <el-form-item :label="carrying002" class="operator-user-selector">
        <employee-input
          v-model="value.carrying002"
          :padding="0"
        ></employee-input>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="总质量">
            <el-input v-model="value.totalQuality" @input="calcWeighingWeightRealB"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="过磅重量">
            <el-input
              v-model="value.weighingWeight"
              @input="calcWeighingWeightReal"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆整备质量"
            ><el-input
              v-model="value.vehicleTare"
              @input="calcWeighingWeightRealA"
            ></el-input
          ></el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="挂车整备质量"
            ><el-input
              v-model="value.carTrailerVehicleTare"
              @input="calcWeighingWeightRealA"
            ></el-input
          ></el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="过磅实重"
            ><el-input disabled v-model="value.weighingWeightReal"></el-input
          ></el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="车辆满载重量"
            ><el-input disabled v-model="VehicleFullLoadWeight"></el-input
          ></el-form-item>
        </el-col> -->

        <el-col :span="8">
          <el-form-item label="实载率"
            ><el-input disabled v-model="value.loadRate"></el-input
          ></el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="装卸点数">
            <el-input v-model="value.loadPoint"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="路线"
            ><el-input v-model="value.routing"></el-input
          ></el-form-item>
        </el-col>
      </el-row>
      <template v-if="realType.includes('gan_xian')">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="核定里程">
              <el-input v-model="value.approvalMileage"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实际行车里程"
              ><el-input v-model="value.drivingMileage"></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="行车时长"
              ><el-input v-model="value.drivingTime"></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="高速入口">
              <el-input v-model="value.highwayEntrance"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高速出口"
              ><el-input v-model="value.highwayExit"></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="场内装载">
              <el-input v-model="value.innerLoad"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="油耗"
              ><el-input v-model="value.fuelUse"></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-row :gutter="20">
 
        <el-col :span="8">
          <el-form-item label="外提重量"
            ><el-input v-model="value.outerCarryingWeight"></el-input
          ></el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="场内装货重量"
            ><el-input v-model="value.loadGoodsWeight"></el-input
          ></el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import EmployeeInput from "@/components/EmployeeInput.vue";
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          VehicleFullLoadWeight: null,
        };
      },
    },
    border: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: {
    EmployeeInput,
  },
  computed: {
    realType() {
      return this.type.replace(":dispatch_type", "");
    },
    carrying001() {
      switch (this.realType) {
        case "gan_xian_pei_zai":
          return "装车搬运";
        default:
          return "随车搬运";
      }
    },
    carrying002() {
      switch (this.realType) {
        case "shang_men_ti_huo":
          return "机动搬运";
        case "gan_xian_pei_zai":
          return "叉车搬运";
        case "song_huo_shang_men":
          return "理货搬运";
        default:
          return "理货搬运";
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    calcWeighingWeightRealA() {
      // 计算过磅实重
      this.calcWeighingWeightReal();

      // 计算车辆满载重量
      this.calcWeighingWeightRealB()
    },
    // 计算过磅实重
    calcWeighingWeightReal() {
      // this.value.weighingWeightReal = this.$TOOLS.add(this.value.weighingWeight || 0,this.value.vehicleTare || 0)
      //整备质量 =  车头加柜的质量
      let num2 = this.$TOOLS.add(
        this.value.carTrailerVehicleTare || 0,
        this.value.vehicleTare || 0
      );
      //实际重量 = 过磅重量-整备质量
      this.value.weighingWeightReal = this.$TOOLS.sub(
        this.value.weighingWeight || 0,
        num2
      );
    },
    // 计算车辆满载重量 = 总质量 - 车头+柜
    calcWeighingWeightRealB() {
      // this.value.weighingWeightReal = this.$TOOLS.add(this.value.weighingWeight || 0,this.value.vehicleTare || 0)

      let num2 = this.$TOOLS.add(
        this.value.carTrailerVehicleTare || 0,
        this.value.vehicleTare || 0
      );
      //计算车辆满载重量 = 总质量 - 车头+柜
      let VehicleFullLoadWeight = this.$TOOLS.sub(
        this.value.totalQuality || 0,
        num2
      );

      console.log('VehicleFullLoadWeight',VehicleFullLoadWeight)

      // 实载率=实际重量/车辆满载重量
      let numA = this.$TOOLS.divide(
        this.value.weighingWeightReal || 0,
        VehicleFullLoadWeight
      );
      // mathToFixed
      this.value.loadRate = numA.toFixed(3);
    },
  },
};
</script>

<style lang="less" scoped>
.operator-user-selector {
  width: 100% !important;
  height: auto !important;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 10px !important;
  //   /deep/ .el-form-item__label {
  //     margin-top: 10px;
  //   }
  /deep/ .el-form-item__content {
    height: auto !important;
  }
}
.box {
  .el-form-item {
    margin-bottom: 18px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    height: 33px;
    line-height: 33px;
    padding: 0px 5px;
    /deep/ .el-form-item__label {
      border: 0;
      overflow: hidden;
      height: 30px;
      line-height: 30px;
    }
    /deep/ .el-form-item__content {
      border: 0;
      height: 33px;
      line-height: 33px;
      .el-input__inner {
        border: 0;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>